import React, { useState, useEffect, useRef } from 'react'

//images
import newReservationImage from "@/assets/img/dashboard/icons/new-reservation.svg"
import editedReservationImage from "@/assets/img/dashboard/icons/edited-reservation.svg"
import deletedReservationImage from "@/assets/img/dashboard/icons/activity-delete.svg"
import filterImage from "@/assets/img/icons/filter.svg"

import Api from '../../../../_helpers/Api'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import { Button } from '@mui/material'
import CompactFilterLayout from '@/components/partials/CompactFilterLayout'
import DateRange from '@/components/partials/DateRange'
import { trans } from '@/_providers/Translation'

function ActivityLog() {
    const compactFilterLayoutRef = useRef(null)

    const history = useHistory()

    const INITIAL_FILTERS = {
        employee_id: null,
        category_id: null,
        section_id: null,
        date_from: null,
        date_to: null
    }

    const [state, setState] = useState({
        loading: true,
        data: [],
        employees: [],
        categories: [],
        sections: [],
        filters: INITIAL_FILTERS
    })

    useEffect(() => {
        loadEmployees()
    }, [])

    useEffect(() => {
        loadData()
    }, [state.filters])

    const loadEmployees = () => {
        Api.get('partners/employees/all?active=1&sort=name')
            .then(res => {
                setState(prev => ({
                    ...prev,
                    employees: res.data || []
                }))
            })
            .catch(err => {
                console.error('Error loading employees:', err)
            })
    }

    const loadData = () => {
        setState(prev => ({
            ...prev,
            loading: true
        }))

        const endpoint = `activities/all?group=all&employee_id=${state.filters.employee_id || ''}&category_id=${state.filters.category_id || ''}&section_id=${state.filters.section_id || ''}&date_from=${state.filters.date_from || ''}&date_to=${state.filters.date_to || ''}`


        Api.get(endpoint)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    data: res.data.items || [],
                    categories: res.data.filters?.categories || prev.categories,
                    sections: res.data.filters?.sections || prev.sections,
                }))
            }).finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const handleShowActivity = id => {
        history.replace('?show_activity=' + id)
    }

    function handleFilterChange(e) {
        const { name, value } = e.target

        setState(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                [name]: value
            }
        }))
    }

    function getAppliedFiltersCount() {
        const { filters } = state
        let count = 0

        Object.keys(filters).forEach(key => {
            if (key === 'date_to') {
                return
            }

            if (key === 'date_from') {
                if (filters.date_from || filters.date_to) {
                    count++
                }
            } else if (filters[key]) {
                count++
            }
        })

        return count
    }

    return (
        <div className="activity-log-list">
            <div className="head">
                <h3>{trans('random.latestActivities')}</h3>
                <div className='right'>
                    <select
                        value={state.filters.employee_id || ''}
                        name='employee_id'
                        onChange={handleFilterChange}
                    >
                        <option value="">{trans('random.allUsers')}</option>
                        {state.employees.map(employee => (
                            <option key={employee.id} value={employee.id}>
                                {employee.name} {employee.lastname}
                            </option>
                        ))}
                    </select>
                    <Button onClick={(e) => {
                        compactFilterLayoutRef.current.open(e)
                    }}>
                        <img src={filterImage} alt="Filter" />
                    </Button>
                    <CompactFilterLayout
                        ref={compactFilterLayoutRef}
                        appliedFiltersCount={getAppliedFiltersCount()}
                        onClearClick={() => {
                            setState(prev => ({
                                ...prev,
                                filters: INITIAL_FILTERS
                            }))
                        }}
                    >
                        <div className='row'>
                            <div className='col'>
                                <DateRange
                                    startDate={state.filters.date_from || ''}
                                    endDate={state.filters.date_to || ''}
                                    onStartDateChange={(date) => {
                                        handleFilterChange({ target: { name: 'date_from', value: date } })
                                    }} onEndDateChange={(date) => {
                                        handleFilterChange({ target: { name: 'date_to', value: date } })
                                    }}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <select
                                    name='category_id'
                                    value={state.filters.category_id || ''}
                                    onChange={handleFilterChange}
                                >
                                    <option value="">{trans('random.allCategories')}</option>
                                    {state.categories.map(cat => (
                                        <option key={cat.id} value={cat.id}>
                                            {cat.translation}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <select
                                    name="section_id"
                                    value={state.filters.section_id || ''}
                                    onChange={handleFilterChange}
                                >
                                    <option value="">{trans('random.allSections')}</option>
                                    {state.sections.map(section => (
                                        <option key={section.id} value={section.id}>
                                            {section.translation}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </CompactFilterLayout>
                </div>
            </div>
            <hr />
            {state.loading ? (
                <div className="activity-loading">
                    <Skeleton height={60} count={6} />
                </div>
            ) : (
                <ul>
                    {state.data.length === 0 ? (
                        <div
                            className="alert info"
                            style={{
                                width: "100%",
                                marginBottom: "auto",
                            }}
                        >
                            {trans("messages.noDataFound")}
                        </div>
                    ) : (
                        state.data.map(activity => {
                            const before = activity.before || {}
                            const after = activity.after || {}
                            const changes = Object.keys(after)
                                .filter(key => key !== 'updated_at' && after[key] !== before[key])
                                .map(key => ({ field: key, from: before[key], to: after[key] }))
                            const isUpdated = activity.event === 'updated'
                            return (
                                <li
                                    key={activity.id}
                                    onClick={!isUpdated || changes.length === 1 ? () => handleShowActivity(activity.id) : undefined}
                                    style={!isUpdated || changes.length === 1 ? { cursor: 'pointer' } : undefined}
                                >
                                    <span className="icon">
                                        <img src={activity.event === 'deleted' ? deletedReservationImage : activity.event === 'updated' || activity.event === 'completed' ? editedReservationImage : newReservationImage} alt="icon" />
                                    </span>
                                    <div className="activity-content">
                                        <b>
                                            {activity.title || activity.trans}
                                        </b>
                                        <div className="employee">
                                            {activity.causer?.full_name}
                                        </div>
                                        {isUpdated && changes.length === 1 && (
                                            <div className="activity-location">
                                                <div className="activity-location-side">
                                                    <span className="activity-location-label">{trans('tables.' + changes[0].field ?? '-')}</span>
                                                    <span className="activity-location-value">{changes[0].from ?? '-'}</span>
                                                </div>
                                                <span className="activity-location-arrow">→</span>
                                                <div className="activity-location-side">
                                                    <span className="activity-location-label">{trans('tables.' + changes[0].field ?? '-')}</span>
                                                    <span className="activity-location-value">{changes[0].to ?? '-'}</span>
                                                </div>
                                            </div>
                                        )}
                                        {isUpdated && changes.length > 1 && (
                                            <span
                                                className="activity-show-all"
                                                onClick={() => handleShowActivity(activity.id)}
                                            >
                                                {trans('buttons.showAllChanges')}
                                            </span>
                                        )}
                                    </div>
                                    <time>
                                        {moment(activity.created_at).format('DD.MM.YYYY')}<br /> {moment(activity.created_at).format('HH:mm')}
                                    </time>
                                </li>
                            )
                        })
                    )}
                </ul>
            )}
        </div>
    )
}

export default ActivityLog